
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import selectTime from "@/components/select-time/select-time.vue";
import { objAny } from "@/common/common-interface";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
import { getSimAlarm, saveSimAlarm } from "@/api/api-basic";
import { getOptionList, optionKey } from "@/api/api-dict";
@Component({
  components: {
    "select-time": selectTime
  }
})
export default class AlarmSettingSIM extends Vue {
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  private privilege!: objAny;
  @Prop({ default: "" }) private tabName!: string;
  @Prop({ default: "" }) private activeTab!: string;
  private batchSettingList: object[] = [];
  private FormData: objAny = {};

  private loading = false;
  private formItem: objAny = {
    alarmLevel: "1",
    flow: ""
  };

  private ruleInline = {
    flow: [
      {
        required: true,
        name: i18n.t("alarmsetting.flow"),
        trigger: "blur",
        validator: regular.int
      }
    ]
  };

  public handleClick(): void {
    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.saveSimAlarm();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    });
  }

  async saveSimAlarm(): Promise<void> {
    const ret = await saveSimAlarm(this.formItem);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("saveSucess"));
    }
  }
  async getOptionList() {
    const ret = await getOptionList([optionKey.batchSettingObj]); //请求字典
    this.batchSettingList = ret[optionKey.batchSettingObj]; // 运营状态
  }
  // async getDictList(): Promise<void> {
  //   const ret = await getDictList({ typeId: "166" });
  //   if (ret.status === this.$config.apiStatus) {
  //     this.batchSettingList = ret.data;
  //   }
  // }
  async getSimAlarm(): Promise<void> {
    const ret = await getSimAlarm({ alarmLevel: this.formItem.alarmLevel });
    if (ret.status === this.$config.apiStatus) {
      this.formItem.flow = ret.data[0];
    }
  }

  public init(newVal: string): void {
    if (newVal === this.tabName) {
      this.getOptionList();
      this.getSimAlarm();
    }
  }
  @Watch("activeTab")
  getVisible(newVal: string) {
    this.init(newVal);
  }
  mounted() {
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
      });
    }
  }
  // public created(): void {
  //   this.getOptionList();
  // }
}
